import React from 'react'
import {Button} from "react-bootstrap";
import {useNavigate} from "react-router-dom";

export const BotonRegresar = () => {

    const navigate = useNavigate();

    return (
        <div>
            <Button className={"boton-regresar-pagina"} onClick={() => navigate(-1)} ><i className="bi bi-arrow-left-circle"></i></Button>
        </div>
    )
}
